import { Component, EventEmitter, forwardRef, Input, OnInit, Output } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { radioGroupOption } from '../../../../pages/report/commonModel/common-classes';


@Component({
  selector: 'radio-group-button',
  templateUrl: './radio-group-button.component.html',
  styleUrls: ['./radio-group-button.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => RadioGroupButtonComponent),
      multi: true
    }
  ]
})
export class RadioGroupButtonComponent implements OnInit, ControlValueAccessor {

  @Input() btnList: radioGroupOption[] = [];
  @Input() isButton: boolean = true;
  @Input() selectedOption: any = null;
  @Input() radioGroupButtonId: any;
  @Input() disabled: boolean = false;
  @Input() boxClasses: string = '';
  @Output() optionChange = new EventEmitter<string>();

  onChange = (_) => {
    // Unused
  };
  onTouched = () => {
    // Unused
  };

  constructor() {
    // Unused
  }

  writeValue(value: string): void {
    // Unused
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  ngOnInit(): void {
    // Unused
  }

  onSelection() {
    this.optionChange.emit(this.selectedOption);
  }

}
